const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2),
        height: '100%'
    },
    logoContainer: {
        paddingTop: 100,
        marginBottom: 30
    },
    text: {
        color: theme.palette.secondary.main,
        textAlign: 'center'
    },
}));

export default useStyles;